import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="w-full bg-white px-5 py-16 sm:py-24" aria-label="What therapists say" data-id="element-302" data-mp="3b0kr27jf9gwk">
      <div className="mx-auto max-w-6xl" data-id="element-303" data-mp="36yzgwty9vgq2">
        <SectionHeading eyebrow="What therapists are saying" title="Clearer Case Organization, in Their Own Words" data-id="element-304" data-mp="3700ub52rgfay" />

        <figure className="mx-auto mt-12 max-w-3xl rounded-3xl bg-ink p-7 text-white sm:p-10" data-id="element-305" data-mp="3229024en8h3l">
          <Stars data-id="element-306" data-mp="2x2mn7w2q92vb" />
          <blockquote className="mt-4 font-heading text-[1.35rem] font-medium leading-snug sm:text-2xl" data-id="element-307" data-mp="2s1ykwe91szls">“{featured.quote}”</blockquote>
          <figcaption className="mt-6 flex items-center gap-4" data-id="element-308" data-mp="v8difd5cpw86">
            <img src={featured.photo} alt={featured.name} className="h-16 w-16 rounded-full object-cover ring-2 ring-gold" data-id="element-309" data-mp="qaljw0a7bbv0" />
            <div data-id="element-310" data-mp="h4wvo4o4mgj9">
              <p className="font-bold" data-id="element-311" data-mp="h4dckkmqpm3n">{featured.name}</p>
              <p className="text-sm text-white/70" data-id="element-312" data-mp="m5kkcjovulab">
                {featured.role} · {featured.location}
              </p>
            </div>
          </figcaption>
        </figure>

        <div className="mt-6 grid gap-6 sm:grid-cols-2" data-id="element-313" data-mp="c6vcljqpah7s">
          {rest.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-paper p-6 ring-1 ring-line sm:p-7" data-id="element-314" data-mp="c8olz6sp7fjh">
              <Stars data-id="element-315" data-mp="14vj2xtqb3ws7" />
              <blockquote className="mt-3 flex-1 leading-relaxed text-ink/85" data-id="element-316" data-mp="14w29keaiayqx">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3.5" data-id="element-317" data-mp="q762ajg9xprd">
                <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover" data-id="element-318" data-mp="v5ps4uxznlp0" />
                <div data-id="element-319" data-mp="1ivacni9sir0e">
                  <p className="font-bold text-ink" data-id="element-320" data-mp="1ius5vrpi4ue8">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-321" data-mp="1it7g0fe4tzmp">
                    {t.role} · {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
        <SectionCta label="I want to organize my cases like this" data-id="element-322" data-mp="1siwfamy7u49w" />
      </div>
    </section>;
}
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-323" data-mp="1ogjca6auskgt">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-324" data-mp="1jhg44czkty4m" data-mpi={i} />)}
    </div>;
}